// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  companyLeaveRights: [],
}

export const mutations = {
  SET_COMPANY_LEAVE_RIGHTS(state, companyLeaveRights) {
    state.companyLeaveRights = companyLeaveRights
  },
  EDIT_COMPANY_LEAVE_RIGHT(state, companyLeaveRight) {
    const index = state.companyLeaveRights.findIndex(
      (el) => el.leave_type_uuid === companyLeaveRight.leave_type_uuid
    )
    if (index !== -1) {
      state.companyLeaveRights.splice(index, 1, companyLeaveRight)
    }
  },
}

export const actions = {
  fetchCompanyLeaveRights({ commit }, payload) {
    return ApiService.fetchCompanyLeaveRights(payload)
      .then((res) => {
        const companyLeaveRights = res.data.data
        commit('SET_COMPANY_LEAVE_RIGHTS', companyLeaveRights)
      })
      .catch((error) => {
        throw error
      })
  },
  editCompanyLeaveRight({ commit }, payload) {
    return ApiService.editCompanyLeaveRight(payload)
      .then((res) => {
        const companyLeaveRight = res.data
        commit('EDIT_COMPANY_LEAVE_RIGHT', companyLeaveRight)
      })
      .catch((error) => {
        throw error
      })
  },
}
